import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const SidebarWrapper = styled.aside`
  width: ${({ theme }) => theme.metrics.sidebarWidth};
  min-width: ${({ theme }) => theme.metrics.sidebarWidth};
  padding-right: 24px;

  @media (max-width: 992px) {
    display: none;
  }
`;

export const SidebarSection = styled.div`
  margin-bottom: 32px;
`;

export const SidebarTitle = styled.h3`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.lg};
  color: ${({ theme }) => theme.colors.text.dark.very};
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.secondary.main};
`;

export const CategoryList = styled.ul`
  list-style: none;
`;

export const CategoryItem = styled.li`
  margin-bottom: 2px;
`;

export const CategoryLink = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  color: ${({ theme }) => theme.colors.text.dark.medium};
  border-radius: ${({ theme }) => theme.metrics.radius.small};
  transition: all 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.bgSecondary};
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const CategoryCount = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const StatBox = styled.div`
  background: ${({ theme }) => theme.colors.info.light};
  border-radius: ${({ theme }) => theme.metrics.radius.medium};
  padding: 16px;
  text-align: center;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }
`;

export const StatNumber = styled.div`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.xl};
  color: ${({ theme }) => theme.colors.secondary.dark};
  font-weight: 700;
`;

export const StatLabel = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  color: ${({ theme }) => theme.colors.text.dark.little};
  margin-top: 4px;
`;

export const RecentItem = styled(Link)`
  display: flex;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  color: ${({ theme }) => theme.colors.text.dark.very};

  &:hover {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const RecentImage = styled.div`
  width: 50px;
  height: 65px;
  background: ${({ theme }) => theme.colors.bgSecondary};
  border-radius: ${({ theme }) => theme.metrics.radius.small};
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const RecentInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const RecentTitle = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RecentPrice = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.secondary.dark};
  font-weight: 600;
  margin-top: 4px;
`;
